/**
 * @module app.cd
 */

import * as CD from 'app/cd/models/essette-api';

abstract class MemberEvent {
    public member?: CD.Member;
}
export class MemberDisplayChangeEvent extends MemberEvent {
    constructor(member?: CD.Member) {
        super();
        this.member = member;
        return Object.assign<MemberDisplayChangeEvent, MemberDisplayChangeEvent>(this, { member });
    }
}

abstract class MemberPlanEvent { }
export class MemberPlanChangeEvent extends MemberPlanEvent {
    constructor(public memberPlan?: CD.MemberPlan) {
        super();
        return Object.assign<MemberPlanChangeEvent, MemberPlanChangeEvent>(this, { memberPlan: memberPlan });
    }
}
